import React from 'react'
import Hero from './Hero'
import VideoPart from './VideoPart'
import ProductList from './ProductList'
import HeroAd from './HeroAd'
import Cta from './Cta'
import ProductSlider from './ProductSlider'
import ContentLetter from './ContentLetter'
import NewsLetter from './NewsLetter'
import CertificateList from './CertificateList'
import ServiceMap from '../../components/ServiceMap'
import ProcessCta from './ProcessCta'
import CupProcess from './CupProcess'

function Index() {
  return (
    <div>
      <Hero />
      <VideoPart />
      <ProductList />
      {/* <HeroAd /> */}
      {/* <ProcessCta /> */}
      <Cta />
      <ProductSlider />
      <CupProcess />
      <ContentLetter />
      <NewsLetter />
      <ServiceMap />
      <CertificateList />
    </div>
  )
}

export default Index